import { Elements, PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Button, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_KEY);

const PaymentForm = ({ setStep, setForm }) => {
  const navigate = useNavigate();

  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);

  const handlePay = async () => {
    if (!stripe || !elements || loading) return;

    setLoading(true);

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // receipt_email: receiptEmail
      },
      redirect: 'if_required'
    });

    setLoading(false);

    if (error) {
      toast.error(error.message || 'Payment failed');
      return;
    }

    if (paymentIntent) {
      if (paymentIntent.status === 'succeeded') {
        toast.success('Thank you, your Payment is successful 🎉');
        setForm({});
        setStep(1);
      } else if (paymentIntent.status === 'processing') {
        toast.info('Payment processing...');
        toast.info('You will receive an email confirmation shortly.');
        setForm({});
        setStep(1);
      } else {
        toast.error('Payment was not successful');
      }
    }
  };

  return (
    <div className="p-2">
      <PaymentElement
      // options={{
      //   layout: 'tabs',
      //   mode: 'payment'
      // }}
      />

      <Button
        onClick={handlePay}
        disabled={!stripe || loading}
        className="mt-4 bg-button-primary text-white px-6 py-2 flex items-center gap-2"
      >
        {loading && <Spinner animation="border" size="sm" />}
        {loading ? 'Processing...' : 'Pay Now'}
      </Button>
    </div>
  );
};

export default PaymentForm;
